import { FEATURE_FLAG_CONFIG } from '../../constants/config';

export const FEATURE_FLAGS = FEATURE_FLAG_CONFIG;

export function isFeatureEnabled(flag: keyof typeof FEATURE_FLAGS): boolean {
    const value = FEATURE_FLAGS[flag];
    return typeof value === 'boolean' ? value : value?.enabled || false;
}